import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import FuseDialog from '@fuse/core/FuseDialog';
import { closeDialog } from 'app/store/fuse/dialogSlice';
import DIALOGS from 'app/constants/dialogs';
import PricingPlans from './PricingPlans';

const UpgradePlanDialog = ({
  tariffs,
  tariffMeta,
  currency,
  currentPlanId,
  currentVariantId,
  subscriptionStatus,
  onSelectPlan,
  // TODO: uncomment when downgrade feature is enabled
  // onDowngrade,
  onLetsTalk,
}) => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeDialog());
  }, [dispatch]);

  return (
    <FuseDialog
      fullWidth
      maxWidth="lg"
      dialogId={DIALOGS.UPGRADE_PLAN}
      onClose={onClose}
      PaperProps={{ sx: { maxWidth: '1100px' } }}
    >
      <Box padding="32px">
        <PricingPlans
          tariffs={tariffs}
          tariffMeta={tariffMeta}
          currency={currency}
          currentPlanId={currentPlanId}
          currentVariantId={currentVariantId}
          subscriptionStatus={subscriptionStatus}
          onSelectPlan={onSelectPlan}
          // onDowngrade={onDowngrade}
          onLetsTalk={onLetsTalk}
        />
      </Box>
    </FuseDialog>
  );
};

export default UpgradePlanDialog;
